import gql from "graphql-tag";
export const QUERYCOWS = gql`
    query fetch($wallet: String) {
        tokens(where: { owner: $wallet }, orderBy: number, orderDirection: asc, first: 1000) {
            id
            owner {
                id
            }
            number
            isGolden
            fur
            head
            ears
            eyes
            nose
            mouth
            feet
            milkRate
            tokenURI
        }
        stakes(where: { owner: $wallet }, first: 1000, orderBy: id, orderDirection: asc) {
            id
            owner {
                id
            }
            token {
                number
                isGolden
                fur
                head
                ears
                eyes
                nose
                mouth
                feet
                milkRate
                tokenURI
            }
            value
        }
        users(orderBy: claimedMilk, orderDirection: desc, first: 10) {
            id
            claimedMilk
            tokens {
                id
                isGolden
            }
        }
        stat(id: "global") {
            totalMilkEarned
            totalMinted
        }
    }
`;

export const parseGraphObject2 = woolfOrStake => {
    if (woolfOrStake.value) {
        return { ...woolfOrStake, ...woolfOrStake.token };
    }
    return woolfOrStake;
};
